
import React from 'react';
import { Globe, Languages } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center p-2 focus:outline-none text-white hover:bg-black/20 rounded-md">
        <Languages className="h-5 w-5" />
        <span className="ml-1 text-sm uppercase">{language}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-black/90 border border-gray-700 z-[100]">
        <DropdownMenuItem 
          onClick={() => setLanguage('en')} 
          className={`text-sm cursor-pointer ${language === 'en' ? 'font-bold' : ''} text-white hover:bg-gray-800`}
        >
          English
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setLanguage('el')} 
          className={`text-sm cursor-pointer ${language === 'el' ? 'font-bold' : ''} text-white hover:bg-gray-800`}
        >
          Ελληνικά
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
